export const getLogoUrl = (theme, urlTemplate) => {
  const defaultTheme = "satellite-theme";

  return urlTemplate.replace("_THEME_NAME_", !!theme ? theme : defaultTheme);
};

export const getLogoClassName = isLeftSectionShown => {
  return "PhyzziBrandLogo__image" + (isLeftSectionShown ? "" : "--enlightened");
};
